import { render, staticRenderFns } from "./RootModal.vue?vue&type=template&id=50e1c496&scoped=true&"
import script from "./RootModal.vue?vue&type=script&lang=js&"
export * from "./RootModal.vue?vue&type=script&lang=js&"
import style0 from "./RootModal.vue?vue&type=style&index=0&id=50e1c496&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e1c496",
  null
  
)

export default component.exports